export type AlignmentType = "left" | "center" | "right" | "justify";

export const availableAlignment: AlignmentType[] = [
  "left",
  "center",
  "right",
  "justify"
];
